module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "medkit"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.suspend-resume-campaign-title')))]), _c('template', {
    slot: "content"
  }, [(_vm.canSuspendCampaign) ? _c('gotu-nav-button', {
    staticClass: "btn-block",
    attrs: {
      "theme": "default-cta",
      "className": "btn-block"
    },
    on: {
      "click": _vm.suspendCampaign
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.suspend-campaign-button')))]) : _vm._e(), (_vm.canResumeCampaign) ? _c('gotu-nav-button', {
    staticClass: "btn-block",
    attrs: {
      "theme": "default-cta",
      "className": "btn-block"
    },
    on: {
      "click": _vm.resumeCampaign
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.resume-campaign-button')))]) : _vm._e()], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7df3280f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/suspend-resume-box/SuspendResumeBox.vue
// module id = 2071
// module chunks = 1